import { useEffect } from "react";
import calculateDurationInMinutes from "../../utils/durationInMinutes";

interface ISessionInformationCard {
  title: string;
  status: string;
  dateTime: string;
  duration: any;
  trainerName: string;
}

export const SessionInformation = ({
  title,
  status,
  dateTime,
  duration,
  trainerName,
}: ISessionInformationCard) => {

  return (
    <div className="w-full rounded-xl bg-white shadow-md p-6">
      <div className="grid grid-cols-2 gap-y-6 text-sm">
        <div>
          <p className="text-gray-500">Status</p>
          <p className="text-app-blue font-medium">{status}</p>
        </div>

        <div>
          <p className="text-gray-500">Date & Time</p>
          <p className="text-app-blue font-medium">{dateTime}</p>
        </div>

        <div>
          <p className="text-gray-500">Duration</p>
          <p className="text-app-blue font-medium">{duration}</p>
        </div>

        <div>
          <p className="text-gray-500">Trainer</p>
          <p className="text-app-blue font-medium">{trainerName}</p>
        </div>
      </div>
    </div>
  );
};
